import React, { useState } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useCollect, useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Button, Input, Select } from 'components/Misc/Form';

const Edit = ({ final, modal, onModal }) => {
	// Store updated data
	const [data, setData] = useState(final);

	// Store requested exams
	const [[exams], collect] = useCollect('finals');

	// Store request
	const [, request] = useRequest('put', `finals/${final.id}`);

	// Handle mark data change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handle submit event
	const onUpdate = async (event) => {
		event.preventDefault();

		// Try to create final
		const [success, error] = await request(data, {
			type: 'student:final'
		});

		console.log(success);
	};

	// Collect user on mount and on parameter change
	useSingleEffect(() => {
		(async () => await collect())();
	});

	return (
		<Modal title="Labot eksāmena datus" visible={modal} handleModal={onModal}>
			<div className="flex flex-col gap-4">
				<Select
					name="finalId"
					label="Eksāmens"
					placeholder=" "
					value={data.finalId}
					onChange={onChange}
					options={exams?.map(exam => ({
						value: exam.id,
						name: exam.title
					}))}
				/>

				<Input
					type="text"
					name="number"
					label="Sertifikāta numurs"
					value={data.number}
					onChange={onChange}
				/>

				<div className="col-span-2 flex justify-end">
					<Button
						icon="check"
						theme="success"
						value="Saglabāt"
						onClick={onUpdate}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Edit;